module.exports = __webpack_public_path__ + "img/Jake.6fcce4dd.jpeg";